
import Card from '../components/base/Card';

export default function Testimonials() {
  const testimonials = [
    {
      name: 'María G.',
      location: 'Cliente verificado',
      rating: 5,
      text: 'Excelente servicio. Llegaron puntuales y dejaron mi casa impecable. Los productos que usan no tienen olor fuerte y son seguros para mis hijos. Definitivamente los recomiendo.',
      service: 'Limpieza Residencial'
    },
    {
      name: 'Carlos R.',
      location: 'Cliente verificado',
      rating: 5,
      text: 'Contraté el servicio de limpieza profunda antes de mudarme y quedé sorprendido con el resultado. Cada rincón quedó perfecto. El equipo es muy profesional y confiable.',
      service: 'Limpieza Profunda'
    },
    {
      name: 'Ana L.',
      location: 'Cliente verificado',
      rating: 5,
      text: 'Llevo 6 meses usando sus servicios para mi oficina y siempre superan mis expectativas. Son puntuales, eficientes y muy cuidadosos con nuestros equipos.',
      service: 'Limpieza Comercial'
    },
    {
      name: 'Roberto M.',
      location: 'Cliente verificado',
      rating: 5,
      text: 'El servicio post-construcción fue increíble. Removieron todo el polvo y residuos de la remodelación. Mi casa quedó lista para habitarla inmediatamente.',
      service: 'Post-construcción'
    }
  ];

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <i
        key={index}
        className={`ri-star-${index < rating ? 'fill' : 'line'} text-yellow-400`}
      ></i>
    ));
  };

  return (
    <section id="testimonios" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 font-outfit">
            Lo que dicen nuestros clientes
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto font-inter">
            La satisfacción de nuestros clientes es nuestra mayor recompensa
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} hover className="h-full">
              <div className="flex flex-col h-full">
                {/* Rating */}
                <div className="flex items-center gap-1 mb-4">
                  {renderStars(testimonial.rating)}
                </div>
                
                {/* Testimonial Text */}
                <blockquote className="text-slate-700 leading-relaxed mb-6 flex-grow font-inter">
                  "{testimonial.text}"
                </blockquote>
                
                {/* Service Badge */}
                <div className="mb-4">
                  <span className="inline-block bg-sky-100 text-sky-700 px-3 py-1 rounded-full text-sm font-medium">
                    {testimonial.service}
                  </span>
                </div>
                
                {/* Author */}
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-sky-400 to-emerald-400 rounded-full flex items-center justify-center">
                    <i className="ri-user-line text-white text-lg"></i>
                  </div>
                  <div>
                    <div className="font-semibold text-slate-900 font-outfit">
                      {testimonial.name}
                    </div>
                    <div className="text-slate-500 text-sm">
                      {testimonial.location}
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
